import { Link } from 'react-router-dom';
import type { Movie } from '@/types/movie';
import { mediaTypeLabels } from '@/types/movie';

interface MovieCardProps {
  movie: Movie;
  showHeat?: boolean;
}

export default function MovieCard({ movie, showHeat = false }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      data-product-shop
      className="group block cursor-pointer"
      title={`${movie.title} - 久久热影视详情`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - ${mediaTypeLabels[movie.type]} - 久久热`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <span className="absolute left-2 top-2 flex items-center h-6 px-2 rounded-md bg-primary-600/90 text-background-50 text-xs font-medium whitespace-nowrap">
          {mediaTypeLabels[movie.type]}
        </span>
        {showHeat && (
          <span className="absolute right-2 top-2 flex items-center gap-1 h-6 px-2 rounded-md bg-accent-500 text-accent-950 text-xs font-semibold whitespace-nowrap">
            <i className="ri-fire-fill text-xs" />
            {Math.round(movie.heat / 100)}°
          </span>
        )}
        <span className="absolute left-2 bottom-2 hidden group-hover:flex items-center gap-1 text-background-50 text-xs font-medium">
          <i className="ri-play-circle-line text-base" />
          查看详情
        </span>
      </div>
      <div className="mt-2.5 px-0.5">
        <h3 className="text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">
          {movie.year} · {movie.region} · {movie.genres.slice(0, 2).join('/')}
        </p>
        <div className="mt-1.5 flex items-center gap-1">
          <i className="ri-star-fill text-accent-500 text-xs" />
          <span className="text-xs font-semibold text-accent-700">{movie.rating.toFixed(1)}</span>
        </div>
      </div>
    </Link>
  );
}